export default {
  data() {
    return {
      allTrainings: [],
    };
  },
  methods: {
    getAllTrainings: function (title = null, offlineProtocol = null) {
      const params = {
        title,
        offlineProtocol,
      };
      this.load.val = true;
      this.$store
        .dispatch('getAllTrainingsDispatch', params)
        .then(() => {
          if (this.$store.state.trainingModule.successFlag) {
            const data = this.$store.state.trainingModule.allTrainings;
            this.allTrainings = data;
          } else {
            if (this.$store.state.chiefComplaintModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.this.getAllAttchments(this.chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.trainingModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.this.getAllAttchments(this.chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
  },
};
